import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController, LoadingController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
import { DatePipe } from '@angular/common';
import { ServicesProvider, } from 'src/providers/services';


@Component({
  selector: 'app-trainer-package-det',
  templateUrl: './trainer-package-det.page.html',
  styleUrls: ['./trainer-package-det.page.scss'],
})
export class TrainerPackageDetPage implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent
  HOC: any;
  storeOfferCards: any;

  isHomeMode: any;
  isOnlineMode: any;
  isCenterMode: any;

  storeOfferCards1: any;
  valuehoc: any;
  cardlen1: any;
  cardlen2: any;
  cardlen3: any;
  trainerId: any;
  trainingId: any;

  checkOnline: any;
  checkHome: any;
  checkCenter: any;
  noResultFound: boolean;
  constructor(
    public modalCtrl: ModalController, private datePipe: DatePipe,
    public addCall: AddCall, public service: ServicesProvider, public loadingController: LoadingController,) { }

  ngOnInit() {
  }
  ionViewWillEnter() {
   
    this.checkHome = this.isHomeMode
    this.checkOnline = this.isOnlineMode
    this.checkCenter = this.isCenterMode

    let finalTrainingMode = this.sortTrainingMode();
    this.trainerId = this.storeOfferCards.trainerId;
    this.trainingId = this.storeOfferCards.tr_training_category_id;

    this.cardlen1 = finalTrainingMode.includes(1);
    this.cardlen2 = finalTrainingMode.includes(2);
    this.cardlen3 = finalTrainingMode.includes(3);

    if (this.checkHome != 0) {
      this.HOC = 'homeList';
      this.chsOffHiglight(this.HOC);
    } else if (this.checkOnline != 0) {
      this.HOC = 'onlineList';
      this.chsOffHiglight(this.HOC);
    } else if (this.checkCenter != 0) {
      this.HOC = 'centerList';
      this.chsOffHiglight(this.HOC);
    } else {
      this.HOC = 'homeList';
      this.chsOffHiglight(this.HOC);
    }


  }

  sortTrainingMode() {
    let jsonArray = this.storeOfferCards.OriginalTrainingMode;
    let jsonParse = JSON.parse(jsonArray);
    let jsonNumber = jsonParse.map(str => Number(str));
    let jsonDuplicate = jsonNumber.filter((value, index, self) => self.indexOf(value) === index);
    let jsonSort = jsonDuplicate.sort((a, b) => a - b);
    return jsonSort;
  }
  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }
  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    let Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "am" : "pm";
        // var ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        // 
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
          let arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear();
          return arDate;
        }
      case "DateTime":
        const formattedDate = this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
        const formattedDateLowercase = formattedDate.replace(/PM/g, 'pm').replace(/AM/g, 'am');
        return formattedDateLowercase
      // return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
          let arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear();
          return arDate;
        }
    }

  }
  async chsOffHiglight(value) {

    this.HOC = value;
    let getDate = new Date();

    let currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    if (value == 'homeList') {
      this.storeOfferCards = [];
      this.storeOfferCards1 = [];

      this.HOC = value;
      let obj = {
        "trainerId": this.trainerId,
        "trainingId": this.trainingId,
        "currentDate": currentDate,
        "patientId": localStorage.getItem("patient_id"),
        "trainingMode": "1"
      }
      this.noResultFound = false;
      const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Please wait...'
      });
      await loading.present();
      this.service.postRequest1("getPackagesBasedOnTrainingMode", obj).subscribe(async (res: any) => {
        await loading.dismiss();
        this.storeOfferCards = res.data;
        const uniqueDataArray = Array.from(new Set(this.storeOfferCards.map(item => item.tr_package_name)))
          .map(tr_package_name => this.storeOfferCards.find(item => item.tr_package_name === tr_package_name));
        this.storeOfferCards1 = uniqueDataArray;
        this.storeOfferCards1.length > 0 ? this.noResultFound = false :this.noResultFound = true; 


      });
    } else if (value == 'onlineList') {
      this.storeOfferCards = [];
      this.storeOfferCards1 = [];
      this.HOC = value;
      this.noResultFound = false;
      const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Please wait...'
      });

      await loading.present();
      this.HOC = value;
      let obj = {
        "trainerId": this.trainerId,
        "trainingId": this.trainingId,
        "currentDate": currentDate,
        "patientId": localStorage.getItem("patient_id"),
        "trainingMode": "2"
      }
      this.service.postRequest1("getPackagesBasedOnTrainingMode", obj).subscribe(async (res: any) => {
        await loading.dismiss();
        this.storeOfferCards = res.data;
        const uniqueDataArray = Array.from(new Set(this.storeOfferCards.map(item => item.tr_package_name)))
          .map(tr_package_name => this.storeOfferCards.find(item => item.tr_package_name === tr_package_name));
        this.storeOfferCards1 = uniqueDataArray;
        this.storeOfferCards1.length > 0 ? this.noResultFound = false :this.noResultFound = true; 
      })
    } else if (value == 'centerList') {
      this.storeOfferCards = [];
      this.storeOfferCards1 = [];
      this.noResultFound = false;
      this.HOC = value; const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Please wait...'
      });
      let obj = {
        "trainerId": this.trainerId,
        "trainingId": this.trainingId,
        "currentDate": currentDate,
        "patientId": localStorage.getItem("patient_id"),
        "trainingMode": "3"
      }
      await loading.present();
      this.service.postRequest1("getPackagesBasedOnTrainingMode", obj).subscribe(async (res: any) => {
        await loading.dismiss();
        this.storeOfferCards = res.data;
        const uniqueDataArray = Array.from(new Set(this.storeOfferCards.map(item => item.tr_package_name)))
          .map(tr_package_name => this.storeOfferCards.find(item => item.tr_package_name === tr_package_name));
        this.storeOfferCards1 = uniqueDataArray;
        this.storeOfferCards1.length > 0 ? this.noResultFound = false :this.noResultFound = true; 
      })

    }
  }
  dismiss() {
    this.modalCtrl.dismiss({
      packdet: "NotSelected",
      coh: null
    });
  }
  totalPackagesArray: any = [];
  packagedet(tr_pack, HOC) {
    
    this.totalPackagesArray = [];
    if (tr_pack.tr_training_mode == '1') {
      for (let i = 0; i <= this.storeOfferCards.length; i++) {
        if (this.storeOfferCards[i] != undefined) {
          if (this.storeOfferCards[i].tr_package_name == tr_pack.tr_package_name) {
            this.totalPackagesArray.push(this.storeOfferCards[i])
          }
        }
      }
      this.homeApi(tr_pack.tr_vendor_id, tr_pack.tr_package_id, HOC);
    } else if (tr_pack.tr_training_mode == '2') {
      for (let i = 0; i <= this.storeOfferCards.length; i++) {
        if (this.storeOfferCards[i] != undefined) {
          if (this.storeOfferCards[i].tr_package_name == tr_pack.tr_package_name) {
            this.totalPackagesArray.push(this.storeOfferCards[i])
          }
        }
      }
      this.OnlineApi(tr_pack.tr_vendor_id, tr_pack.tr_package_id, HOC);
    } else if (tr_pack.tr_training_mode == '3') {
      for (let i = 0; i <= this.storeOfferCards.length; i++) {
        if (this.storeOfferCards[i] != undefined) {
          if (this.storeOfferCards[i].tr_package_name == tr_pack.tr_package_name) {
            this.totalPackagesArray.push(this.storeOfferCards[i])
          }
        }
      }
      this.OnlineApi(tr_pack.tr_vendor_id, tr_pack.tr_package_id, HOC);
    }
  }

  forDismiss(HOC) {    
    this.modalCtrl.dismiss({
      packdet: this.CommonDates,
      coh: HOC

    });
  }



  CommonDates: any = [];
  validatefor: any;
  trainerHomepackage :any;
  async homeApi(tr_vendor_id, tr_package_id, HOC) {
    
    this.CommonDates = [];
    this.validatefor = null;
    if (this.trainerHomepackage) {
      this.trainerHomepackage.unsubscribe();
    }
    let apiData = {
      "patientId": localStorage.getItem("patient_id"),
      "trainerId": tr_vendor_id,
      "packageId": tr_package_id,
    }

    this.trainerHomepackage = this.service.postRequest1("getHomeDates", apiData).subscribe(async (res: any) => {
      if (res.status != 0) {
        for (let i = 0; i <= res.data.length; i++) {
          if (res.data[i] != undefined) {
            this.validatefor = res.data.length
            this.CommonDates.push({

              "tr_slot_duration": this.totalPackagesArray[0].tr_slot_duration,
              "tr_no_of_slots": this.totalPackagesArray[0].tr_no_of_slots,
              "tr_vendor_id": this.totalPackagesArray[0].tr_vendor_id,
              "tr_package_id": this.totalPackagesArray[0].tr_package_id,
              "tr_training_mode": this.totalPackagesArray[0].tr_training_mode,
              "is_vip": this.totalPackagesArray[0].is_vip,
              "tr_package_name": this.totalPackagesArray[0].tr_package_name,
              "tr_tainingcategory_id": this.totalPackagesArray[0].tr_tainingcategory_id,
              "tr_training_id": this.totalPackagesArray[0].tr_training_id,
              "tr_session": this.totalPackagesArray[0].tr_session,
              "tr_cost": this.totalPackagesArray[0].tr_cost,
              "tr_max_booking": this.totalPackagesArray[0].tr_max_booking,
              "tr_package_details": this.totalPackagesArray[0].tr_package_details,
              "tr_package_profile_path": this.totalPackagesArray[0].tr_package_profile_path,
              "tr_package_status": this.totalPackagesArray[0].tr_package_status,
              "tr_reschedule": this.totalPackagesArray[0].tr_reschedule,
              "dealId": this.totalPackagesArray[0].dealId,
              "dealName": this.totalPackagesArray[0].dealName,
              "dealOption": this.totalPackagesArray[0].dealOption,
              "dealValue": this.totalPackagesArray[0].dealValue,
              "programDays": this.totalPackagesArray[0].programDays,
              "featuresList": this.totalPackagesArray[0].featuresList,
              "dealserviceid": this.totalPackagesArray[0].dealserviceid,
              "defaultTrainingMode": this.totalPackagesArray[0].defaultTrainingMode,
              "ProgDays1": [],//this.totalPackagesArray[0].ProgDays1,
              "ProgDays2": [],//this.totalPackagesArray[0].ProgDays2,
              "appointmentScheduleId": res.data[i].appointmentScheduleId,
              "tr_from_time": res.data[i].tr_from_time,
              "tr_to_time": res.data[i].tr_to_time,
              "days": res.data[i].days,
              "dates": res.data[i].dates,
              "WeekDay": res.data[i].WeekDay,
              "month": res.data[i].month,
              "monthName": res.data[i].monthName,
              "year": res.data[i].year,
              "remainMode_isReche": res.data[i].remainMode_isReche,
              "isReschedule": res.data[i].isReschedule,
            });
          }
        }
        this.CommonDates = this.removeDuplicates(this.CommonDates);
        this.forDismiss(HOC)
      }
    });

  }
  trainerOnlpackage :any;
  OnlineApi(tr_vendor_id, tr_package_id, HOC) {
    this.CommonDates = [];
    this.validatefor = null;
    if (this.trainerOnlpackage) {
      this.trainerOnlpackage.unsubscribe();
    }
    let apiData = {
      "patientId": localStorage.getItem("patient_id"),
      "trainerId": tr_vendor_id,
      "packageId": tr_package_id,
    }

   this.trainerOnlpackage = this.service.postRequest1("getOnlineDates", apiData).subscribe(async (res: any) => {
      if (res.status != 0) {
        for (let i = 0; i <= res.data.length; i++) {
          if (res.data[i] != undefined) {
            this.validatefor = res.data.length;
            this.CommonDates.push({

              "tr_slot_duration": this.totalPackagesArray[0].tr_slot_duration,
              "tr_no_of_slots": this.totalPackagesArray[0].tr_no_of_slots,
              "tr_vendor_id": this.totalPackagesArray[0].tr_vendor_id,
              "tr_package_id": this.totalPackagesArray[0].tr_package_id,
              "tr_training_mode": this.totalPackagesArray[0].tr_training_mode,
              "is_vip": this.totalPackagesArray[0].is_vip,
              "tr_package_name": this.totalPackagesArray[0].tr_package_name,
              "tr_tainingcategory_id": this.totalPackagesArray[0].tr_tainingcategory_id,
              "tr_training_id": this.totalPackagesArray[0].tr_training_id,
              "tr_session": this.totalPackagesArray[0].tr_session,
              "tr_cost": this.totalPackagesArray[0].tr_cost,
              "tr_max_booking": this.totalPackagesArray[0].tr_max_booking,
              "tr_package_details": this.totalPackagesArray[0].tr_package_details,
              "tr_package_profile_path": this.totalPackagesArray[0].tr_package_profile_path,
              "tr_package_status": this.totalPackagesArray[0].tr_package_status,
              "tr_reschedule": this.totalPackagesArray[0].tr_reschedule,
              "dealId": this.totalPackagesArray[0].dealId,
              "dealName": this.totalPackagesArray[0].dealName,
              "dealOption": this.totalPackagesArray[0].dealOption,
              "dealValue": this.totalPackagesArray[0].dealValue,
              "programDays": this.totalPackagesArray[0].programDays,
              "featuresList": this.totalPackagesArray[0].featuresList,
              "dealserviceid": this.totalPackagesArray[0].dealserviceid,
              "defaultTrainingMode": this.totalPackagesArray[0].defaultTrainingMode,
              "ProgDays1": [],//this.totalPackagesArray[0].ProgDays1,
              "ProgDays2": [],//this.totalPackagesArray[0].ProgDays2,
              "appointmentScheduleId": res.data[i].appointmentScheduleId,
              "tr_from_time": res.data[i].tr_from_time,
              "tr_to_time": res.data[i].tr_to_time,
              "days": res.data[i].days,
              "dates": res.data[i].dates,
              "WeekDay": res.data[i].WeekDay,
              "month": res.data[i].month,
              "monthName": res.data[i].monthName,
              "year": res.data[i].year,
              "remainMode_isReche": res.data[i].remainMode_isReche,
              "isReschedule": res.data[i].isReschedule,
            });


          }
        }
        this.CommonDates = this.removeDuplicates(this.CommonDates);
        this.forDismiss(HOC)
      }

    })
  }
  removeDuplicates(array) {
    const uniqueObjects = {};
    const resultArray = [];
    array.forEach(obj => {
        const key = obj.dates + obj.tr_from_time;
        if (!uniqueObjects[key]) {
            uniqueObjects[key] = true;
            resultArray.push(obj);
        }
    });
    return resultArray;
}

}
